import type { AegisDocumentSources } from '@move-right/aegis/core/documentDerivation';
import type { AegisDocumentOption, AegisOptionChoices, AegisOptionValues } from '@move-right/aegis/core/documentOptions';
import type { AegisDocumentContext } from '@move-right/aegis/core/types/documentContext';

import { BaseArtifactFragment } from '../../../generated/graphql.generated';

export interface CreateDocumentDialogInput {
  jobId: string;
  docType?: string;
  options?: AegisOptionValues;
}

export interface AegisDocumentPreview {
  docType: string;
  kind: string;
  templateSource: string;
  context: AegisDocumentContext;
  options: AegisDocumentOption[];
  values: AegisOptionValues;
  missing: string[];
  problems: string[];
  sources: AegisDocumentSources;
  choices: AegisOptionChoices;
}

export type CreateDocumentSubmission = 'send' | 'create';

export interface CreateDocumentResult {
  artifact?: BaseArtifactFragment;
  sent: boolean;
  sendError?: string;
  createError?: string;
}

export interface CreateDocumentDraft {
  docType: string;
  seed: AegisOptionValues;
  preview: AegisDocumentPreview | undefined;
  previewLoading: boolean;
  previewError: string | undefined;
  values: AegisOptionValues;
  edited: boolean;
  message: string;
  result: CreateDocumentResult | undefined;
  resending: boolean;
  creating: boolean;
}

export interface CreateDocumentDialogState {
  session: number;
  open: boolean;
  jobId: string | undefined;
  documents: CreateDocumentDraft[];
  unticked: CreateDocumentDraft[];
  docTypeOrder: string[];
  previewing: string | undefined;
  submitting: CreateDocumentSubmission | undefined;
  submitted: CreateDocumentSubmission | undefined;
  submitErrors: { docType: string; message: string }[];
  finished: boolean;
}

export const createDocumentDialogInitialState: CreateDocumentDialogState = {
  session: 0,
  open: false,
  jobId: undefined,
  documents: [],
  unticked: [],
  docTypeOrder: [],
  previewing: undefined,
  submitting: undefined,
  submitted: undefined,
  submitErrors: [],
  finished: false,
};

export const newDocumentDraft = (docType: string, seed: AegisOptionValues = {}): CreateDocumentDraft => ({
  docType,
  seed,
  preview: undefined,
  previewLoading: true,
  previewError: undefined,
  values: {},
  edited: false,
  message: '',
  result: undefined,
  resending: false,
  creating: false,
});
